export const shopIdToShopKey = (shopId) => {
  return shopId.split('offline_')[1].split('.myshopify.com')[0];
};

export const shopKeyToShopId = (shopKey) => {
  return `offline_${shopKey}.myshopify.com`;
};
